export default function GeneralIcon(props: { fill?: string }) {
  return (
    <svg
      width="23"
      height="23"
      viewBox="0 0 23 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_4264_12827)">
        <g clipPath="url(#clip1_4264_12827)">
          <path
            d="M5.89811 20.1295C5.89811 20.0649 5.89811 20.0003 5.89811 19.9357C5.88131 19.4655 6.03515 18.8583 5.79857 18.5638C5.58913 18.3054 4.94659 18.3933 4.4941 18.3338C3.68995 18.2279 3.11723 17.5471 3.09396 16.6544C2.997 13.0373 6.17607 9.47315 9.78308 9.15407C10.0396 9.11366 10.2992 9.09637 10.5588 9.1024C11.253 9.16441 11.681 9.0068 11.8839 8.21233C12.074 7.47211 12.7695 7.23053 13.5232 7.2202C14.4218 7.20857 15.3397 7.16465 15.8103 8.14257C15.9499 8.45535 16.0065 8.79885 15.9745 9.13986C15.7909 11.2158 15.5957 13.2918 15.3565 15.3639C15.2625 16.1734 14.8771 16.9211 14.2723 17.4678C13.6674 18.0144 12.8843 18.3227 12.0688 18.3351C11.5737 18.3467 11.0772 18.3532 10.5833 18.3351C10.1955 18.3222 10.0404 18.4721 10.0494 18.8648C10.0675 19.6605 10.061 20.4576 10.0494 21.2534C10.0378 22.3256 9.39006 22.965 8.31312 22.9793C8.03258 22.9793 7.75204 22.9896 7.47278 22.9793C7.05919 22.9743 6.66385 22.8083 6.37077 22.5167C6.0777 22.225 5.90999 21.8307 5.90329 21.4174C5.88648 20.9885 5.90329 20.5571 5.90329 20.1256L5.89811 20.1295Z"
            fill={props.fill ?? 'white'}
          />
          <path
            d="M14.4638 21.1435C14.0759 21.1435 13.6881 21.1706 13.3002 21.1435C12.7184 21.0918 12.3474 20.6926 12.381 20.1798C12.4198 19.6153 12.7689 19.3194 13.3041 19.2858C13.9505 19.2458 14.5969 19.2768 15.2434 19.2678C16.01 19.2574 16.2647 19.0262 16.3927 18.2601C16.9012 15.2347 17.4114 12.2092 17.9234 9.18371C18.0527 8.44737 18.4509 8.08953 19.0055 8.18513C19.5601 8.28072 19.8588 8.73157 19.7411 9.47696C19.3946 11.6602 19.0223 13.8382 18.6564 16.0175C18.5155 16.8637 18.3681 17.7098 18.2195 18.5547C17.9105 20.3154 16.9098 21.1538 15.1167 21.1629H14.4702L14.4638 21.1435Z"
            fill={props.fill ?? 'white'}
          />
          <path
            d="M10.5392 3.54615C10.5353 3.18066 10.6042 2.81805 10.7419 2.47944C10.8796 2.14083 11.0834 1.83299 11.3414 1.57388C11.5994 1.31477 11.9064 1.10956 12.2446 0.970211C12.5827 0.830866 12.9453 0.760173 13.3111 0.762252C14.0483 0.759682 14.7563 1.04984 15.2794 1.56889C15.8025 2.08795 16.0978 2.79338 16.1003 3.53C16.1029 4.26662 15.8125 4.9741 15.2931 5.49678C14.7736 6.01947 14.0676 6.31456 13.3305 6.31713C12.9643 6.32125 12.601 6.25252 12.2616 6.11495C11.9223 5.97737 11.6138 5.77371 11.354 5.51582C11.0942 5.25793 10.8884 4.95096 10.7485 4.6128C10.6086 4.27465 10.5375 3.91205 10.5392 3.54615Z"
            fill={props.fill ?? 'white'}
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_4264_12827">
          <rect
            width="22.2298"
            height="22.2298"
            fill={props.fill ?? 'white'}
            transform="translate(0.314453 0.760254)"
          />
        </clipPath>
        <clipPath id="clip1_4264_12827">
          <rect
            width="16.6724"
            height="22.2298"
            fill={props.fill ?? 'white'}
            transform="translate(3.0918 0.760254)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}
